export class Page {
  id: string;
  fake_background_image?: string;
  icon_url?: string;
  chat_window_css?: string;
  override_default_chat_window_css?: string;
  jwt: string;
  privacy_link?: string;
  lang_code?: string;
  persistent_menu: PersistentMenuItem[];
  enable_watermark: boolean;
  enable_waiting_time: boolean;
}

export enum PersistentMenuItemType {
  Restart = 'alcmeon_restart_conversation',
  Url = 'web_url',
  Postback = 'postback',
  Transcript = 'transcript',
}

export interface PersistentMenuItem {
  type: PersistentMenuItemType;
  title: string;
  urlOrPayload?: string;
}

export const persistentMenuMock: PersistentMenuItem[] = [
  {
    type: PersistentMenuItemType.Restart,
    title: 'Restart Item',
  },
  {
    type: PersistentMenuItemType.Url,
    urlOrPayload: 'https://domain.com/persistent/meu/url',
    title: 'url menu item',
  },
  {
    type: PersistentMenuItemType.Postback,
    urlOrPayload: 'postback:metadata',
    title: 'postback menu item',
  },
];
